"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToPlainText = exports.emailMatchesDomains = exports.getDomain = exports.removeEmailSubAddressing = exports.formatEmail = void 0;
const _ = require("lodash");
const parseDomain = require("parse-domain");
const html_to_text_1 = require("./html-to-text");
const formatEmail = (value) => {
    let formatted = _.toLower(value);
    if (formatted.match(/@gmail\.com$/)) {
        let username = formatted.replace(/@gmail\.com$/, '');
        username = username.replace(/\./g, '');
        const match = username.match(/\+/);
        if (match) {
            username = username.substring(0, match.index);
        }
        formatted = username + '@gmail.com';
    }
    return formatted;
};
exports.formatEmail = formatEmail;
const removeEmailSubAddressing = (value) => {
    const formatted = value;
    // tslint:disable-next-line: prefer-const
    let [username, ...domain] = formatted.split('@');
    username = username.split('+')[0];
    return username.concat('@').concat(...domain);
};
exports.removeEmailSubAddressing = removeEmailSubAddressing;
const getDomain = (email) => {
    const parsed = parseDomain(email);
    if (parsed) {
        const domain = `${parsed.domain}.${parsed.tld}`;
        if (domain === 'getrocket.io' || domain === 'hirewithrocket.com') {
            return 'getrocket.ai';
        }
        else {
            return domain;
        }
    }
    else {
        return null;
    }
};
exports.getDomain = getDomain;
/** Matches an email's hostname against configured domains and their subdomains. */
function emailMatchesDomains(email, configuredDomains) {
    const parsed = parseDomain(email);
    if (!parsed || !parsed.domain) {
        return false;
    }
    const hostname = [parsed.subdomain, parsed.domain, parsed.tld].filter(Boolean).join('.');
    const rootDomain = (0, exports.getDomain)(email); // Retain the existing Rocket domain aliases.
    return configuredDomains.some((configuredDomain) => {
        const domain = configuredDomain.toLowerCase();
        return hostname === domain || hostname.endsWith(`.${domain}`) || rootDomain === domain;
    });
}
exports.emailMatchesDomains = emailMatchesDomains;
function convertToPlainText(input) {
    return (0, html_to_text_1.htmlToText)(input);
}
exports.convertToPlainText = convertToPlainText;
//# sourceMappingURL=email-utils.js.map